import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import featureFlag from "@/utils/feature";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: Home,
    meta: { title: "Home" },
  },
  {
    path: "/product/:id",
    name: "Product",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "shopping-cart" */ "../views/Product.vue"),
    meta: { title: "Product" },
  },
  {
    path: "/shopping-cart",
    name: "ShoppingCart",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "shopping-cart" */ "../views/ShoppingCart.vue"
      ),
    meta: { title: "Shopping Cart" },
  },
  {
    path: "/order",
    name: "Order",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "order" */ "../views/Order.vue"),
    meta: { title: "Order" },
  },
  {
    path: "/payment",
    name: "Payment",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "payment" */ "../views/Payment.vue"),
    meta: { title: "Payment" },
  },
  {
    path: "/payment/stripecheckout",
    name: "PaymentStripeCheckout",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "paymentStripeCheckout" */ "../views/PaymentStripeCheckoutResult"
      ),
    meta: { title: "Payment Result" },
  },
  {
    path: "/payment/alipay",
    name: "PaymentAlipay",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "paymentAlipay" */ "../views/PaymentOmipayResult"
      ),
    meta: { title: "Payment Result" },
  },
  {
    path: "/orders",
    name: "Orders",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "orders" */ "../views/Orders.vue"),
    meta: { title: "My Orders" },
  },
  {
    path: "/order/:id",
    name: "OrderDetail",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "order" */ "../views/Order.vue"),
    meta: { title: "Order Detail" },
  },
  {
    path: "/reservation",
    name: "Reservation",
    component: () =>
      import(/* webpackChunkName: "reservation" */ "../views/Reservation.vue"),
    meta: { title: "Reservation" },
  },
  {
    path: "/reservations",
    name: "Reservations",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "reservations" */ "../views/Reservations.vue"
      ),
    meta: { title: "My Reservations" },
  },
  {
    path: "/personal",
    name: "Personal",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "personal" */ "../views/Personal.vue"),
    meta: { title: "Personal Centre" },
  },
  {
    path: "/points",
    name: "Points",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "points" */ "../views/Points.vue"),
    meta: { title: "Points" },
  },
  {
    path: "/check-in-form",
    name: "CheckInForm",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(/* webpackChunkName: "checkinform" */ "../views/CheckInForm.vue"),
    meta: { title: "Check-In Form" },
  },
  {
    path: "/password-recovery",
    name: "PasswordRecovery",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "passwordrecovery" */ "../views/PasswordRecovery"
      ),
    meta: { title: "Recover Your Password" },
  },
  {
    path: "/queue",
    name: "Queue",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "queue" */
        "../views/Queue"
      ),
    meta: { title: "Your Queue" },
  },
  {
    path: "/po/:shortCode",
    name: "PreOrderRedirect",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "pre-order" */
        "../views/PreOrderRedirect"
      ),
    meta: { title: "Pre-Order" },
  },
  {
    path: "/o/:orderNumber",
    name: "OrderDetailRedirect",
    ...(featureFlag.RECEIVE_BOOKING_ONLY ? { redirect: "/reservation" } : {}),
    component: () =>
      import(
        /* webpackChunkName: "order-detail" */
        "../views/OrderDetailRedirect"
      ),
    meta: { title: "Order Detail" },
  },
  {
    path: "*",
    redirect: featureFlag.RECEIVE_BOOKING_ONLY ? "/reservation" : "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const DEFAULT_TITLE = "King Dynasty Express 唐宴在线";

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title =
      (to.meta.title && `${to.meta.title} | ${DEFAULT_TITLE}`) || DEFAULT_TITLE;
  });
});

export default router;
